export const ru = {
    'correction-text': 'Цена клика {correctionSign} на {correction}%',
    'on-condition-mobile': 'по условию «Мобильные устройства»',
    'on-condition-perfomance': 'по условию «Смарт-объявления»',
    'on-condition-video': 'по условию «Объявления с видеодополнениями»',
    'sign-less': 'уменьшена',
    'sign-more': 'увеличена'
};
